import React, { useContext } from 'react';

import LedgerContext from '../../contexts/LedgerContext';

import getSelectedItems from '../../helpers/rows/getSelectedItems';
import getSelectedIndexes from '../../helpers/rows/getSelectedIndexes';

const BulkActions = ({ bulkActions }) => {
  const { selected, data } = useContext(LedgerContext);

  if (bulkActions) {
    const BulkActions = bulkActions;
    return <BulkActions selected={getSelectedItems(selected, data)} getSelectedIndexes={getSelectedIndexes(data)} />;
  }

  return null;
};

export default BulkActions;
